import { render, staticRenderFns } from "./EmptyDesignationIcon.vue?vue&type=template&id=1e495bde"
import script from "./EmptyDesignationIcon.vue?vue&type=script&lang=js"
export * from "./EmptyDesignationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports